// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".personalDetailContent{margin-right:50px}.personalDetailContent .title{height:32px;background:#f4f8fc;box-shadow:inset 0 -2px 3px hsla(0,0%,90.6%,.5);padding:0 20px;box-sizing:border-box;font-size:16px;font-weight:700;line-height:32px;margin-bottom:20px}.personalDetailContent .title span{padding-left:7px;border-left:3px solid #3394e1;color:rgba(2,21,37,.45)}", ""]);
// Exports
module.exports = exports;
